import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-ok-erfassen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentOkErfassenEffects {

    IncidentOkErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_OK_ERFASSEN),
        mergeMap((x: ac.PostIncidentOkErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentOkErfassen(x.incidentRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentOkErfassenErfolgreichAction(result, x.incidentRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentOkErfassenFehlerAction(error, x.incidentRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
